(function () {
  const MOBILE_MAX = 767;

  function setupCHubBarcode() {
    // SPのみ
    if (window.innerWidth > MOBILE_MAX) return false;

    const hub = document.querySelector('accounts-hub');
    if (!hub || !hub.shadowRoot) return false;

    const root = hub.shadowRoot;

    // Announcement
    const announcement = root.querySelector('#ann-bar .announcement-bar');

    // C:Hubの「バーコード番号」フィールド
    const barcodeInput = root.querySelector(
      'input[placeholder="バーコード番号"]'
    );

    if (!announcement || !barcodeInput) return false;

    const barcodeNumber = barcodeInput.value.trim();

    // C:Hubがまだ値をセットしていない
    if (!barcodeNumber) return false;

    // 二重生成防止
    if (announcement.querySelector('.member-barcode')) return true;

    const barcodeUrl =
      'https://bwipjs-api.metafloor.com/?bcid=code128' +
      '&text=' + encodeURIComponent(barcodeNumber) +
      '&scaleX=4' +
      '&scaleY=1' +
      '&includetext=false';

    announcement.innerHTML = `
      <div class="member-barcode">
        <div class="member-barcode__title">MEMBER CODE</div>

        <img
          src="${barcodeUrl}"
          alt="Member barcode"
          class="member-barcode__image"
        >

        <div class="member-barcode__number">
          ${barcodeNumber}
        </div>
      </div>
    `;

    return true;
  }

  function initCHubBarcode() {
    // すでにC:Hubの描画が完了している場合
    if (setupCHubBarcode()) return;

    // C:Hubは後から描画されるため監視
    const observer = new MutationObserver(function () {
      if (setupCHubBarcode()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Shadow DOM生成後に値がセットされるケース対策
    const waitForHub = setInterval(function () {
      const hub = document.querySelector('accounts-hub');

      if (!hub || !hub.shadowRoot) return;

      clearInterval(waitForHub);

      const shadowObserver = new MutationObserver(function () {
        setupCHubBarcode();
      });

      shadowObserver.observe(hub.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true
      });

      setupCHubBarcode();
    }, 300);

    setTimeout(function () {
      clearInterval(waitForHub);
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCHubBarcode);
  } else {
    initCHubBarcode();
  }
})();